import styled from '@emotion/styled'
import { useEffect } from 'react'
import { useRouter } from 'react-router5'

import LoadingSpinnerBase from 'design-system/components/LoadingSpinner'
import isAuthenthicated from 'web-client/utils/isAuthenticated'
import userService from 'shared/utils/user'
// eslint-disable-next-line no-restricted-imports -- use datadog and rollbar directly
import logging from 'shared/utils/logging'
import useCurrentUser from 'web-client/hooks/useCurrentUser'
import relayService from 'shared/utils/relay'

const LoadingSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
`
const LoadingSpinner = styled(LoadingSpinnerBase)`
  width: 120px;
  height: 120px;
`

function RedirectToHome() {
  const { currentUser, isLoading } = useCurrentUser()
  const router = useRouter()

  useEffect(() => {
    if (!isAuthenthicated()) {
      router.navigate('login', {}, { replace: true })
    }
  }, [router])

  useEffect(() => {
    if (isLoading) {
      return
    }

    if (currentUser.permissions.isClient) {
      router.navigate('client', {}, { replace: true })
    } else if (currentUser.permissions.isPartner || currentUser.permissions.isSuperCompany) {
      router.navigate('partner/dispatch', {}, { replace: true })
    } else {
      logging.logWarning('Unable to determine home route for user', {})
      void userService.logout(relayService.environment)
    }
  }, [currentUser, isLoading, router])

  return (
    <LoadingSpinnerContainer>
      <LoadingSpinner />
    </LoadingSpinnerContainer>
  )
}

export default RedirectToHome
